import React, { useEffect } from "react";
import { Col, Row, Form } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import MultiSelect from "components/common/MultiSelect";
import { handlePatientFilter } from "../config/PatientSlice";

const PatientFilter = ({ control, setValue, clearErrors, errors }) => {
    const dispatch = useDispatch();
    const { userData } = useSelector((state) => state.auth);
    const { patientFilters } = useSelector((state) => state.patient);
    const allBranches = JSON.parse(localStorage.getItem("branch_settings")) || [];
    const { allPermissionType } = useSelector((state) => state.role);

    const branchSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
        (item) => item?.rolemngmttyp_name === "Branch"
    );

    const allowedBranchIds = userData?.employee?.branch_id
        ? userData?.employee?.branch_id
            ?.toString()
            ?.split(",")
            ?.map((id) => Number(id.trim()))
        : [];

    const filteredBranches = allBranches.filter((branch) =>
        allowedBranchIds.length > 0
            ? allowedBranchIds.includes(Number(branch.branch_id))
            : true
    );

    const handleBranch = (selected) => {
        if (!selected) {
            setValue("branch_id", null);
            dispatch(handlePatientFilter({ check: "branch_id", value: null }));
            return;
        }
        const value = {
            branch_name: selected.label,
            branch_id: selected.value,
        };
        setValue("branch_id", value);
        dispatch(handlePatientFilter({ check: "branch_id", value }));
        clearErrors("branch_id");
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setValue(name, value);
        dispatch(handlePatientFilter({ check: name, value }));
    };

    useEffect(() => {
        if (patientFilters) {
            setValue("branch_id", patientFilters.branch_id);
            setValue("patient_name", patientFilters.patient_name);
            setValue("patient_national_id", patientFilters.patient_national_id);
            setValue("patient_mobile_no", patientFilters.patient_mobile_no);
            setValue("patient_email", patientFilters.patient_email);
            setValue("patient_mrn", patientFilters.patient_mrn);
        }
    }, [patientFilters, setValue]);

    return (
        <Row className="align-items-center g-3">
            {userData?.employee?.syspri_id === 1 && Number(branchSetting?.list) === 1 && (
                <Col xs={12} sm={6} md={3} xl={2}>
                    <Form.Label>Branch</Form.Label>
                    <Controller
                        name="branch_id"
                        control={control}
                        render={({ field }) => (
                            <MultiSelect
                                {...field}
                                errors={errors}
                                isMulti={false}
                                options={filteredBranches?.map((item) => ({
                                    value: item.branch_id,
                                    label: item.branch_name,
                                }))}
                                isClearable={true}
                                placeholder="Choose ..."
                                value={field.value ? { value: field.value.branch_id, label: field.value.branch_name } : null}
                                onChange={handleBranch}
                            />
                        )}
                    />
                </Col>
            )}

            <Col xs={12} sm={6} md={3} xl={2}>
                <Form.Group controlId="patient_name">
                    <Form.Label>Patient Name</Form.Label>
                    <Form.Control
                        type="text"
                        name="patient_name"
                        placeholder="Enter name"
                        size="sm"
                        {...control.register("patient_name")}
                        onChange={handleInputChange}
                    />
                </Form.Group>
            </Col>

            <Col xs={12} sm={6} md={3} xl={2}>
                <Form.Group controlId="patient_national_id">
                    <Form.Label>National ID</Form.Label>
                    <Form.Control
                        type="text"
                        name="patient_national_id"
                        placeholder="Enter national ID"
                        size="sm"
                        {...control.register("patient_national_id")}
                        onChange={handleInputChange}
                    />
                </Form.Group>
            </Col>

            <Col xs={12} sm={6} md={3} xl={2}>
                <Form.Group controlId="patient_mobile_no">
                    <Form.Label>Mobile No</Form.Label>
                    <Form.Control
                        type="text"
                        name="patient_mobile_no"
                        placeholder="Enter mobile no"
                        size="sm"
                        {...control.register("patient_mobile_no")}
                        onChange={handleInputChange}
                    />
                </Form.Group>
            </Col>

            <Col xs={12} sm={6} md={3} xl={2}>
                <Form.Group controlId="patient_email">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                        type="email"
                        name="patient_email"
                        placeholder="Enter email"
                        size="sm"
                        {...control.register("patient_email")}
                        onChange={handleInputChange}
                    />
                </Form.Group>
            </Col>

            <Col xs={12} sm={6} md={3} xl={2}>
                <Form.Group controlId="patient_mrn">
                    <Form.Label>MRN</Form.Label>
                    <Form.Control
                        type="text"
                        name="patient_mrn"
                        placeholder="Enter MRN"
                        size="sm"
                        {...control.register("patient_mrn")}
                        onChange={handleInputChange}
                    />
                </Form.Group>
            </Col>
        </Row>
    );
};

export default PatientFilter;
